import type { OSType } from '@app/types/OSTypes';

const getUserAgent = () => window.navigator.userAgent.toLowerCase();

export const defineOperationSystem = (): OSType => {
  const userAgent = getUserAgent();
  const patterns = {
    windows: /windows/,
    android: /android/,
    apple: /mac|apple|iphone/,
    linux: /linux/,
  };

  for (const [os, regex] of Object.entries(patterns)) {
    if (regex.test(userAgent)) {
      return os as OSType;
    }
  }

  return 'other';
};
